import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ServicesGrid from "@/components/sections/ServicesGrid";
import Process from "@/components/sections/Process";
import CTA from "@/components/sections/CTA";

export default function Services({ onOpenPalette }: { onOpenPalette: () => void }) {
  return (
    <>
      <Navbar onOpenPalette={onOpenPalette} />
      <main className="pt-28 pb-12 page-fade" data-testid="services-page">
        <div className="container-edx text-center max-w-3xl mx-auto pt-16">
          <div className="section-index mx-auto">EDX.01</div>
          <h1 className="display mt-4 text-4xl md:text-6xl text-white">
            Everything your business needs to <span className="gradient-text">go digital</span>.
          </h1>
          <p className="mt-5 text-edx-muted">
            Six service lines. One delivery process. Built to last.
          </p>
        </div>
        <ServicesGrid index="02" />
        <Process />
        <CTA />
      </main>
      <Footer />
    </>
  );
}
